export default {
  //Generic
  "TASK_FAILURE": "The verification did not complete because a task aborted.",
  "VERIFICATION_WARNINGS": "The verification finished with warnings.",

  //FTP
  "FTP_FILE_NOT_FOUND": "The file to download could not be found on the ftp server.",

  //Extract
  "EXTRACT_ERROR": "The archive downloaded from the ftp server couldn't be extracted.",

  //Filescan
  "FILESCAN_PASSWORD_REQUIRED": "One or more files require a password.",

  //Salesforce
  "SalesforceMalformedRequest": "The request to salesforce contained errors, possibly a wrong contract_id format.",
  "SALESFORCE_TOO_MANY_DEPOTS": "Found more than 1 depot with status 'In progress'",
  "SALESFORCE_NO_DEPOTS": "Found no depots with status 'In progress'",
}



// WEBPACK FOOTER //
// ./src/components/Verification/errors.js